import { useToast } from '@cad-arc';
import { useMutation } from '@tanstack/react-query';
import { CadSearchResource, EventSearchPdfExportRequest } from '@mark43/cad-api';
import { errorOccurredWhile } from '../common/helpers/error-occurred-while';
import { createApiErrorHandler } from '@m43/core';
import { useApiClient } from '~/api-client';

export function useBulkExportEventSearchResultsMutation() {
    const apiClient = useApiClient();
    const toast = useToast();
    return useMutation((args: EventSearchPdfExportRequest) => {
        return apiClient
            .request<CadSearchResource.ExportEventSearchToPdf>({
                method: 'POST',
                url: 'cad_search/event/export/pdf',
                data: args,
            })
            .catch(
                createApiErrorHandler(() => {
                    toast({
                        status: 'error',
                        description: errorOccurredWhile('exporting results'),
                    });
                })
            );
    });
}
